"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIBetaButton = _interopRequireDefault(require("UIComponents/button/UIBetaButton/UIBetaButton"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIDropdown = _interopRequireDefault(require("UIComponents/dropdown/UIDropdown"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _Feedback = require("ui-addon-opt/lib/Feedback");

var _UIOptConstants = require("ui-addon-opt/constants/UIOptConstants");

var _OptActions = require("ui-addon-opt/state/OptActions");

var Optout = function Optout(_ref) {
  var dispatch = _ref.dispatch,
      feedbackSurveyId = _ref.feedbackSurveyId,
      learnMore = _ref.learnMore,
      onFeedbackSurveyClick = _ref.onFeedbackSurveyClick,
      onLearnMoreClick = _ref.onLearnMoreClick,
      onView = _ref.onView,
      optOutButtonText = _ref.optOutButtonText,
      showHubOptin = _ref.showHubOptin,
      showHubOptout = _ref.showHubOptout,
      showIcon = _ref.showIcon,
      showUserOptout = _ref.showUserOptout;
  var FeedbackLoader = (0, _Feedback.getFeedbackLoader)();
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_UIDropdown.default, {
    Button: _UIBetaButton.default,
    buttonText: optOutButtonText,
    icon: showIcon ? undefined : 'none',
    onOpenComplete: onView,
    style: _UIOptConstants.POSITIONING
  }, _react.default.createElement(_UIList.default, null, showUserOptout && _react.default.createElement(_UIButton.default, {
    onClick: function onClick() {
      return dispatch({
        type: _OptActions.ACTION_USER_OPT_OUT
      });
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "ui-addon-opt.optout.options.userOptout"
  })), showHubOptout && _react.default.createElement(_UIButton.default, {
    onClick: function onClick() {
      return dispatch({
        type: _OptActions.ACTION_HUB_OPT_OUT
      });
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "ui-addon-opt.optout.options.hubOptout"
  })), showHubOptin && _react.default.createElement(_UIButton.default, {
    onClick: function onClick() {
      return dispatch({
        type: _OptActions.ACTION_HUB_OPT_IN
      });
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "ui-addon-opt.optin.options.hubOptin"
  })), learnMore && _react.default.createElement(_UIButton.default, {
    href: learnMore.url,
    onClick: onLearnMoreClick,
    target: "_blank"
  }, learnMore.text), feedbackSurveyId && _react.default.createElement(_UIButton.default, {
    onClick: onFeedbackSurveyClick
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "ui-addon-opt.optout.options.submitFeedback"
  })))), feedbackSurveyId && _react.default.createElement(FeedbackLoader, null));
};

Optout.propTypes = {
  dispatch: _propTypes.default.func.isRequired,
  feedbackSurveyId: _propTypes.default.number,
  learnMore: _propTypes.default.shape({
    text: _propTypes.default.node.isRequired,
    url: _propTypes.default.string.isRequired
  }),
  onFeedbackSurveyClick: _propTypes.default.func.isRequired,
  onLearnMoreClick: _propTypes.default.func.isRequired,
  onView: _propTypes.default.func,
  optOutButtonText: _propTypes.default.node.isRequired,
  showIcon: _propTypes.default.bool.isRequired,
  showHubOptin: _propTypes.default.bool.isRequired,
  showHubOptout: _propTypes.default.bool.isRequired,
  showUserOptout: _propTypes.default.bool.isRequired
};
Optout.defaultProps = {
  onFeedbackSurveyClick: _emptyFunction.default,
  onLearnMoreClick: _emptyFunction.default,
  onView: _emptyFunction.default,
  optOutButtonText: _react.default.createElement(_FormattedMessage.default, {
    message: "ui-addon-opt.optout.label"
  }),
  showHubOptin: false,
  showHubOptout: false,
  showUserOptout: true,
  showIcon: true
};
var _default = Optout;
exports.default = _default;
module.exports = exports.default;